<template>
  <div>
    <AllOrders :selectedStatuses="statuses" :issues="true" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllOrders = defineAsyncComponent(() =>
  import("@/components/orders/AllOrders")
);
export default {
  name: "RequiresAttentionOrders",
  components: {
    AllOrders,
  },
  data() {
    return {
      // statuses: ["ACTIVE", "PARTIAL"],
    };
  },
};
</script>
